// extracted by mini-css-extract-plugin
export default {"root":"BundleFeature-root","isEven":"BundleFeature-isEven","content":"BundleFeature-content","image":"BundleFeature-image"};